export default __webpack_public_path__ + "static/media/Options_Icon.9c45e517.svg";